<template>
  <div class="fixed-plugin" v-click-outside="closeDropDown">
    <div class="dropdown show-dropdown" :class="{ show: isOpen }">
      <a data-toggle="dropdown">
        <i class="fa fa-cog fa-2x" @click="toggleDropDown"></i>
      </a>
      <ul class="dropdown-menu" :class="{ show: isOpen }">
        <li class="header-title">MRK</li>

        <li class="text-center" style="width: 100%;">
          <md-field :class="[{ 'md-error': errors.has('MRK') }]">
            <label>{{$lang.inputs.value}}</label>
            <md-input
              v-model="MRK"
              data-vv-name="MRK"
              type="text"
              name="MRK"
              v-validate="modelValidations.MRK"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('MRK')">close</md-icon>
            </slide-y-down-transition>
            <span class="md-suffix">kW</span>
          </md-field>
        </li>

        <li class="header-title">RK</li>

        <li class="text-center" style="width: 100%;">
          <md-field :class="[{ 'md-error': errors.has('RK') }]">
            <label>{{$lang.inputs.value}}</label>
            <md-input
              v-model="RK"
              data-vv-name="RK"
              type="text"
              name="RK"
              v-validate="modelValidations.MRK"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('RK')">close</md-icon>
            </slide-y-down-transition>
            <span class="md-suffix">kW</span>
          </md-field>
        </li>

        <li class="button-container">
          <div class>
            <md-button class="md-success md-block" @click="save()">{{$lang.keys.save}}</md-button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import { SlideYDownTransition } from "vue2-transitions";

export default {
  props: {},

  components: {
    SlideYDownTransition
  },

  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    }
  },

  watch: {
    selectedDevice: function(newDevice, oldDevice) {
      if (newDevice.mac !== oldDevice.mac) {
        this.loadData();
      }
    }
  },

  data() {
    return {
      isOpen: false,
      modelValidations: {
        MRK: {
          required: true,
          regex: /^[0-9]+.{0,1}[0-9]{0,3}$/,
          max_value: 100000000,
          min_value: 0
        }
      },
      MRK: null,
      RK: null
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    toggleDropDown() {
      this.isOpen = !this.isOpen;
    },

    closeDropDown() {
      this.isOpen = false;
    },

    save() {
      this.$validator.validateAll().then(res => {
        if (res) {
          axios({
            method: "POST",
            url: this.$ENDPOINTS.API_W + "/devices/details",
            data: {
              token: getSelectedDeviceToken(this.selectedDevice.mac),
              MRK: Number(this.MRK),
              RK: Number(this.RK)
            },
            withCredentials: true
          })
            .then(response => {
              this.$emit("onUpdate", {
                MRK: this.MRK,
                RK: this.RK
              });
              this.closeDropDown();
            })
            .catch(error => {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            });
        }
      });
    },

    loadData() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/devices/details",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac)
        },
        withCredentials: true
      })
        .then(response => {
          this.MRK = response.data.data.MRK;
          this.RK = response.data.data.RK;
          this.$emit("onUpdate", {
                MRK: this.MRK,
                RK: this.RK
              });
        })
        .catch(error => {
          this.MRK = 0;
          this.$refs.snackbar.notify(
            this.$lang.messages.api_communication_error
          );
        });
    }
  }
};
</script>

<style scoped>
.fixed-plugin {
  top: 150px;
}

.centered-row {
  display: flex;
  height: 100%;
  align-items: center;
}

.button-container .btn {
  margin-right: 10px;
}

.centered-buttons {
  display: flex;
  justify-content: center;
}
</style>
